module.exports = __webpack_public_path__ + "media/images/workplace/banners/recruit_page_header_image-d72787ef4c8a29d5b946cd029390f662.jpg";